import { LOADING_HIDE, LOADING_SHOW } from '../../constant';

const initialState = {
  isLoading: false,
};

const LoadingReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case LOADING_HIDE:
      return { ...state, isLoading: false };
    case LOADING_SHOW:
      return { ...state, isLoading: true };
    default:
      return state;
  }
};

export default LoadingReducer;
export { LoadingReducer };
